import { BillingView } from '@/features/billing';
import { useViewer } from '@/features/session';

export function BillingPage() {
  const { workspace } = useViewer();
  return workspace ? <BillingView workspace={workspace} /> : null;
}
